var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 4.37504V30.625H18.9583V25.5209H16.0417V30.625H7.29167V4.37504H27.7083ZM21.875 10.2084H24.7917V7.29171H21.875V10.2084ZM16.0417 10.2084H18.9583V7.29171H16.0417V10.2084ZM10.2083 10.2084H13.125V7.29171H10.2083V10.2084ZM21.875 16.0417H24.7917V13.125H21.875V16.0417ZM16.0417 16.0417H18.9583V13.125H16.0417V16.0417ZM10.2083 16.0417H13.125V13.125H10.2083V16.0417ZM21.875 21.875H24.7917V18.9584H21.875V21.875ZM16.0417 21.875H18.9583V18.9584H16.0417V21.875ZM10.2083 21.875H13.125V18.9584H10.2083V21.875ZM21.875 27.7084H24.7917V24.7917H21.875V27.7084ZM10.2083 27.7084H13.125V24.7917H10.2083V27.7084ZM30.625 1.45837H4.375V33.5417H30.625V1.45837Z",
    fill: "#D2232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSegment);
export default __webpack_public_path__ + "static/media/office-segment.6a5412dd5105b3737f7e8f4c5f28c3de.svg";
export { ForwardRef as ReactComponent };